import { BoardValue } from '../../jscaip/AI/BoardValue';
import { HeuristicWithBounds } from '../../jscaip/AI/Heuristic';
import { Coord } from '../../jscaip/Coord';
import { P4Rules } from './P4Rules';
export class P4Heuristic extends HeuristicWithBounds {
    getBoardValue(node, _config) {
        const state = node.gameState;
        let score = 0;
        for (let x = 0; x < state.getWidth(); x++) {
            // for every column, starting from the bottom of each column
            for (let y = state.getHeight() - 1; y !== -1 && state.board[y][x].isPlayer(); y--) {
                // while we haven't reached the top or an empty space
                const squareScore = P4Rules.get().P4_HELPER.getSquareScore(state, new Coord(x, y));
                score += squareScore;
            }
        }
        return BoardValue.of(score);
    }
    // When there exists a minimal/maximal value for a heuristic, it is useful to know it.
    getBounds(config) {
        // Experimentally, we hardly find a board with value >20 on a regular board.
        // So we'll count 2 per square to be safe
        const max = 2 * config.width * config.height;
        return {
            player0Best: BoardValue.ofSingle(max, 0),
            player1Best: BoardValue.ofSingle(0, max),
        };
    }
}
